import type { SpinnerProps } from '../../types/spinner.type.ts';

export function BrandSpinner({ size = 56, className = '' }: SpinnerProps) {
  return <div
    style={{ width: size, height: size }}
    className={`relative ${className}`}
    role="status"
    aria-label="로딩 중"
  >
    {/* Glow */}
    <div
      className="absolute inset-0 animate-pulse rounded-full blur-2xl"
      style={{ background: 'radial-gradient(circle, rgba(33,150,243,0.5), transparent 70%)' }}
    />

    {/* Rotating cube with pulsing faces */}
    <svg
      viewBox="0 0 100 100"
      className="absolute inset-0 animate-spin-slow"
      style={{ filter: 'drop-shadow(0 4px 12px rgba(33,150,243,0.4))' }}
    >
      <polygon
        points="50,10 85,30 50,50 15,30"
        fill="#2196f3"
        className="animate-cube-face"
        style={{ animationDelay: '0s', transformOrigin: 'center' }}
      />
      <polygon
        points="15,30 50,50 50,90 15,70"
        fill="#0d2847"
        className="animate-cube-face"
        style={{ animationDelay: '0.4s', transformOrigin: 'center' }}
      />
      <polygon
        points="85,30 50,50 50,90 85,70"
        fill="#1976d2"
        className="animate-cube-face"
        style={{ animationDelay: '0.8s', transformOrigin: 'center' }}
      />
    </svg>
  </div>
}